import services from '../../../services'

const state = {
  info: {}
}
const actions = {
  async findDeviceActions ({commit}, query) {
    console.log('findDeviceActions=============>', query);
    return await services.deviceActions_findDeviceActions(query)
  }
}

const mutations = {
  deviceActionsInfo(state, payload) {
    let deviceActionsInfo = payload || {}
    state.info = deviceActionsInfo
  }
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/deviceActions.js